/**
 * Copyright (C) Sitevision AB 2002-2025, all rights reserved
 *
 */
(function ($, window, document, undefined) {
  var pluginName = 'svDialog',
    defaults = {
      cssClasses: {},
      open: false,
      modal: true,
      movable: false,
      url: undefined,
      title: 'My fancy dialog',
      closeOnEscape: true,
      onClose: null,
      closeButtonLabel: 'Close',
    };

  function getDialogWrapper(modal) {
    var html = '';

    if (modal) {
      html +=
        '<div class="sv-dialog-container">' +
        '<div class="sv-dialog-backdrop"></div>';
    }

    html +=
      '<div class="sv-dialog" role="dialog" aria-hidden="true" aria-labelledby="sv-dialog-title">' +
      '<div class="sv-dialog-content">' +
      '<div class="sv-dialog-header">' +
      '<button class="sv-dialog-close"><span aria-hidden="true">&times;</span></button>' +
      '<h4 id="sv-dialog-title"></h4>' +
      '</div>' + // end sv-dialog-header
      '<div class="sv-dialog-body"></div>' +
      '<div class="sv-dialog-footer"></div>' +
      '</div>' + // end sv-dialog-content
      '</div>'; // end sv-dialog

    if (modal) {
      html += '</div>'; // end sv-dialog-container
    }

    return $(html);
  }

  function Plugin(element, options) {
    this.element = element;
    this.$element = $(element);

    this.options = $.extend({}, defaults, options);
    this._defaults = defaults;
    this._name = pluginName;
    this.init();
  }

  Plugin.prototype = {
    init: function () {
      this.$dialogWrapper = getDialogWrapper(this.options.modal);

      this.$dialogWrapper.find('.sv-dialog-body').append(this.element);

      if (this.options.buttons) {
        this.setupButtons();
      }

      this.bindEvents();

      if (!this.options.modal) {
        this.$dialogWrapper.addClass('sv-dialog-movable');
        this.$dialogWrapper.draggable({
          handle: '.sv-dialog-header',
          containment: 'body',
          distance: 10,
        });
      }

      if (this.options.open) {
        this.open();
      }
    },

    open: function () {
      if (this.options.url) {
        $.get(this.options.url).done($.proxy(this.handleRemoteContent, this));
        return;
      }

      this._open();
    },

    handleRemoteContent: function (response) {
      this.$element.html(response);
      this._open();
    },

    _open: function () {
      this.$dialogWrapper.appendTo('body');

      this.setTitle();

      this.setCloseButton();

      this.setAriaHidden(false);

      this.$dialogWrapper
        .find('.sv-dialog-container')
        .css('height', $(window).height());

      if (this.options.modal) {
        $('body').addClass('sv-dialog-open');
      } else {
        this.positionDialog();
      }

      this.$dialogWrapper.show();
      this.setFocus();
      this.setupFocusTrap();

      this.$element.trigger('open:dialog.sv-dialog');
    },

    setCloseButton: function () {
      this.$dialogWrapper
        .find('.sv-dialog-close')
        .attr('aria-label', this.options.closeButtonLabel);
    },

    setTitle: function () {
      this.$dialogWrapper.find('#sv-dialog-title').html(this.options.title);
    },

    setAriaHidden: function (hidden) {
      var $dialog = this.options.modal
        ? this.$dialogWrapper.find('.sv-dialog')
        : this.$dialogWrapper;
      $dialog.attr('aria-hidden', hidden);
    },

    positionDialog: function () {
      var width = this.$dialogWrapper.outerWidth();
      this.$dialogWrapper.css({
        position: 'fixed',
        top: '30px',
        left: '50%',
        marginLeft: '-' + window.parseInt(width, 10) / 2 + 'px',
      });
    },

    setupButtons: function () {
      $.each(
        this.options.buttons,
        $.proxy(function (index, button) {
          var $button = $('<button class="sv-dialog-btn" />');
          $button.text(button.text).on('click', button.callback);

          switch (button.type) {
            case 'primary':
              $button.addClass('sv-dialog-btn-primary');
              break;
            case 'link':
              $button.addClass('sv-dialog-btn-link');
              break;
          }

          $button.prependTo(this.$dialogWrapper.find('.sv-dialog-footer'));
        }, this)
      );
    },

    setupFocusTrap: function () {
      var self = this;
      var $dialogContent = this.$dialogWrapper.find('.sv-dialog-content');

      // Get all focusable elements within the dialog
      this.getFocusableElements = function () {
        return $dialogContent
          .find(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          )
          .filter(':visible')
          .not(':disabled');
      };

      // Handle keyboard navigation
      $dialogContent
        .off('keydown.focustrap')
        .on('keydown.focustrap', function (e) {
          if (e.key === 'Escape' && self.options.closeOnEscape) {
            e.preventDefault();
            self.close();
            return;
          }

          if (e.key === 'Tab') {
            var $focusableElements = self.getFocusableElements();

            if ($focusableElements.length === 0) {
              return;
            }

            var firstElement = $focusableElements.first()[0];
            var lastElement = $focusableElements.last()[0];

            if (e.shiftKey) {
              // Shift + Tab: if focused on first element, move to last
              if (document.activeElement === firstElement) {
                e.preventDefault();
                lastElement.focus();
              }
            } else {
              // Tab: if focused on last element, move to first
              if (document.activeElement === lastElement) {
                e.preventDefault();
                firstElement.focus();
              }
            }
          }
        });
    },

    removeFocusTrap: function () {
      if (this.$dialogWrapper) {
        this.$dialogWrapper.find('.sv-dialog-content').off('keydown.focustrap');
      }
    },

    close: function () {
      this.removeFocusTrap();
      this.$dialogWrapper.hide();
      this.setAriaHidden(true);

      $('body').removeClass('sv-dialog-open');

      if (this.options.onClose && typeof this.options.onClose === 'function') {
        this.options.onClose();
      }
    },

    remove: function () {
      $('body').removeClass('sv-dialog-open');
      this.removeFocusTrap();
      this.$dialogWrapper.remove();
    },

    setFocus: function () {
      var $inputs = this.$element.find(
        'input:not([type=hidden], .svhidden, .sv-hidden, .env-d--none),select'
      );
      if ($inputs.length) {
        $inputs.first().trigger('focus');
      }
    },

    enableSubmitButton: function () {
      this.$dialogWrapper
        .find('button.sv-dialog-btn-primary')
        .prop('disabled', false);
    },

    disableSubmitButton: function () {
      this.$dialogWrapper
        .find('button.sv-dialog-btn-primary')
        .prop('disabled', true);
    },

    bindEvents: function () {
      this.$dialogWrapper
        .off('click.sv-dialog.close')
        .on(
          'click.sv-dialog.close',
          '.sv-dialog-close',
          $.proxy(this.close, this)
        );
    },

    setURL: function (url) {
      this.options.url = url;
    },
  };

  $.fn[pluginName] = function (options, value) {
    return this.each(function () {
      var plugin = $.data(this, 'plugin_' + pluginName);
      if (!plugin) {
        $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
      } else {
        if (typeof options === 'string') {
          plugin[options](value);
        }
      }
    });
  };
})(window.$svjq, window, document);
